import { Col, Form, Image, InputNumber, message, Modal, Row } from "antd"
import React, { useEffect, useState } from "react"
import TransactionManagement from "src/services/TransactionService"
import QRCode from "qrcode"

const ModalDeposite = ({
  setRefresh,
  depositVisible,
  setDepositVisible,
  handleCancel,
  depositAmount,
  onSuccess,
}) => {
  // const [formDeposit] = Form.useForm()
  // const [depositAmount, setDepositAmount] = useState(null)
  const [qrCode, setQrCode] = useState("") // Mã QR
  const [infoAccBank, setInfoAccBank] = useState({
    bankName: "",
    accountNumber: "",
    userName: "",
  })
  const [successDeposit, setSuccessDeposit] = useState({})
  const [qrVisible, setQrVisible] = useState(false)
  useEffect(() => {
    handleDeposit()
  }, [depositAmount])
  const handleDeposit = async () => {
    try {
      // const { depositAmount } = await formDeposit.validateFields()
      // setDepositAmount(depositAmount)

      // 1. Gọi API depositStaff trước
      const confirmResponse = await TransactionManagement.createDepositeLeader({
        amount: Number(depositAmount),
      })

      // 2. Kiểm tra và lấy content từ phản hồi
      const transactionContent = confirmResponse?.transaction_code
      if (!transactionContent) {
        message.error("Không lấy được nội dung giao dịch!")
        return
      }

      // 3. Gọi API getBankingQr với content từ bước trên
      const qrResponse = await TransactionManagement.getBankingQr({
        amount: depositAmount,
        content: transactionContent,
      })

      // 4. Kiểm tra phản hồi và hiển thị QR
      if (qrResponse?.success?.data) {
        const qrCodeData = qrResponse.success.data.qrCode
        const qrImage = await QRCode.toDataURL(qrCodeData)

        setQrCode(qrImage)
        setInfoAccBank({
          bankName: qrResponse.success.data.bankName,
          accountNumber: qrResponse.success.data.accountNumber,
          userName: qrResponse.success.data.userName,
        })
        setQrVisible(true)
      } else {
        message.error("Có lỗi xảy ra khi tạo mã QR!")
        return
      }

      // 5. Lưu confirmResponse vào state nếu cần
      setSuccessDeposit(confirmResponse)
    } catch (error) {
      console.error("Lỗi xử lý:", error)
      const errorMessage =
        error?.response?.data?.message ||
        "Có lỗi xảy ra khi thực hiện nạp tiền!"
      message.error(errorMessage)
    }
  }
  const confirmDeposit = () => {
    // formDeposit.resetFields()
    handleCancel()
    onSuccess()
    setQrVisible(false)
    if (successDeposit?.message?.includes("thành công")) {
      message.success(successDeposit?.message)
    } else {
      message.error(successDeposit?.message || "Tạo giao dịch thất bại")
    }
    setRefresh?.(prev => !prev)
  }
  return (
    <Modal
      title="Nạp tiền vào ví"
      visible={depositVisible}
      onCancel={handleCancel}
      onOk={confirmDeposit}
      okText={qrVisible ? "Xác nhận giao dịch" : "Nạp tiền"}
    >
      {/* <Form form={formDeposit} layout="vertical">
        <Form.Item
          name="depositAmount"
          label="Số tiền nạp"
          rules={[
            { required: true, message: "Vui lòng nhập số tiền nạp!" },
            // {
            //   type: "number",
            //   min: 100000,
            //   message: "Số tiền nạp tối thiểu là 100,000!",
            // },
          ]}
        >
          <InputNumber
            min={10000} // Đặt số tiền tối thiểu là 100,000
            formatter={value =>
              value
                ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : ""
            }
            parser={value => value.replace(/\$\s?|(,*)/g, "")} // Xóa dấu $ và dấu phẩy
            placeholder="Nhập số tiền"
            disabled={qrVisible}
          />
        </Form.Item>
      </Form> */}
      {qrVisible && ( // Hiển thị mã QR nếu qrVisible là true
        <Row>
          <Col span={24}>
            <div style={{ textAlign: "center" }}>
              <p>Mã QR Chuyển Tiền</p>
            </div>
          </Col>
          <Col span={12}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Image
                src={qrCode} // Hiển thị mã QR dưới dạng hình ảnh
                alt="QR Code"
                preview={false}
              />
            </div>
          </Col>
          <Col span={12}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: 8,
              }}
            >
              <p
                style={{
                  color: "#2C7BE5",
                  fontSize: 20,
                  fontWeight: "bold",
                }}
              >
                {infoAccBank.bankName}
              </p>
              <p
                style={{
                  color: "#FF0033",
                  fontSize: 20,
                  fontWeight: "bold",
                }}
              >
                {infoAccBank.accountNumber}
              </p>
              <p style={{ color: "#333", fontSize: 18, fontStyle: "italic" }}>
                {infoAccBank.userName}
              </p>
              <p
                style={{
                  color: "#28a745",
                  fontSize: 22,
                  fontWeight: "600",
                }}
              >
                {/* {Number(amount).toLocaleString()} VND */}{" "}
                {depositAmount?.toLocaleString()}
              </p>
            </div>
          </Col>
          <Row style={{ marginTop: 16 }}>
            <Col span={24} style={{ textAlign: "center" }}>
              <p
                style={{
                  color: "#ff6600",
                  fontSize: 16,
                  fontWeight: 500,
                }}
              >
                ⚠️ Lưu ý: Nếu bạn đã nạp tiền thành công, vui lòng ấn{" "}
                <b style={{ color: "#2C7BE5" }}>Xác nhận giao dịch</b> để hoàn
                tất.
              </p>
            </Col>
          </Row>
        </Row>
      )}
    </Modal>
  )
}

export default ModalDeposite
